export default __webpack_public_path__ + "ad12c8ad814e7eb21e5265182c9cf1c5.png";